import { Button } from '@/components';
import { isPS } from '@/utils';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

export const NavigateReportPageButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Button
      onClick={() => {
        navigate(
          isPS()
            ? `${location.pathname.replace('/public-site', '')}/report`
            : '/rs/project/report',
        );
      }}
    >
      {t('report-projects')}
    </Button>
  );
};
